import React from 'react'
import { cn } from '@/lib/utils.ts'

export const SIZE_STYLES = {
  xxs: 'text-[0.625rem] leading-[100%]', // 10px
  small: 'text-xs', // 12px
  medium: 'text-sm', // 14px
  base: 'text-base', // 16px
  large: 'text-lg', // 18px
  copySm: 'text-xs leading-[133%]',
  copyMd: 'text-sm leading-[143%] md:text-sm',
  copyMdMd: 'text-sm font-medium leading-[143%]',
}

export const VARIANT_STYLES = {
  default: 'text-foreground',
  secondary: 'text-secondary-foreground',
  muted: 'text-muted-foreground',
  primaryForeground: 'text-primary-foreground',
}

export type TextVariantT = keyof typeof VARIANT_STYLES

export type TextElementProps = {
  className?: string
  variant?: TextVariantT
  size?: keyof typeof SIZE_STYLES
  children?: React.ReactNode
  text?: string | number | undefined | null
}

const Paragraph = ({
  className,
  children,
  size = 'copyMd',
  variant = 'default',
  text,
}: TextElementProps) => {
  return (
    <p className={cn(VARIANT_STYLES[variant], SIZE_STYLES[size], className)}>{text ?? children}</p>
  )
}
export default Paragraph
